import { fetchAuthSession, getCurrentUser, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { STRATA_COGNITO_CONFIG } from '../../config/bootstrap';

export const isStrataAuthenticated = async (): Promise<boolean> => {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
};

const claimAsString = (value: unknown): string | null => {
  return typeof value === 'string' && value ? value : null;
};

const displayNameFromPayload = (payload: Record<string, unknown> | undefined): string | null => {
  const name = claimAsString(payload?.name);
  if (name) {
    return name;
  }
  const given = claimAsString(payload?.given_name);
  const family = claimAsString(payload?.family_name);
  const combined = [given, family].filter(Boolean).join(' ');
  return combined || null;
};

export const getStrataDisplayIdentity = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    const payload = session.tokens?.idToken?.payload as Record<string, unknown> | undefined;
    let email = claimAsString(payload?.email);
    if (!email) {
      const user = await getCurrentUser();
      email = user.signInDetails?.loginId || user.username || null;
    }
    const name = displayNameFromPayload(payload);
    if (name && email && name !== email) {
      return `${name} (${email}) - ADMIN`;
    }
    if (email) {
      return `${email} - ADMIN`;
    }
    return name ? `${name} - ADMIN` : null;
  } catch {
    return null;
  }
};

export const getStrataIdToken = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || null;
  } catch {
    return null;
  }
};

export const loginStrata = async (): Promise<void> => {
  await signInWithRedirect({
    provider: { custom: STRATA_COGNITO_CONFIG.IDP_NAME },
  });
};

export const signOutStrata = async (): Promise<void> => {
  await signOut();
};
